import styled from 'styled-components'
import { brandOrange, brandSoftGrey, brandWhite } from '../../../../assets/consts/color'
import { secondaryFont } from '../../../../assets/consts/fonts'

export const Container = styled.div`
  --react-international-phone-background-color: transparent;
  --react-international-phone-font-size: 16px;
  --react-international-phone-text-color: ${brandSoftGrey};
  --react-international-phone-height: auto;
  --react-international-phone-dropdown-top: 68px;
  --react-international-phone-border-color: ${brandSoftGrey};

  font-family: ${secondaryFont};

  border-bottom: 2px solid ${({ focused }) => (focused ? brandOrange : brandSoftGrey)};

  &:hover {
    border-bottom: 2px solid ${brandOrange};
  }

  .react-international-phone-input-container .react-international-phone-input {
    padding: 16px 24px;
    font-weight: 300;
    flex-grow: 1;
    border: none;
    border-radius: 0;
  }

  .react-international-phone-input-container .react-international-phone-country-selector-button {
    height: 100%;
    border: none;
    border-radius: 0;

    &:hover {
      background-color: transparent;
    }
  }

  .react-international-phone-country-selector {
    flex-shrink: 0;
  }

  .react-international-phone-country-selector-dropdown {
    width: 270px;
    background-color: ${brandWhite};
    &:focus {
      outline: none;
    }
  }
`
